import { adminHttpClient } from "../../../../commons/adminHttpClinet";
import { AddMarketplaceCategoryModel } from "../../../../models/dashboard/marketplace/marketplaceCategoryModel";

 const addNewCategory = (category: AddMarketplaceCategoryModel ): Promise<any> => {
  return adminHttpClient.post("/api/Admin/AdminMarketplace/add-category", category);
};
export  default addNewCategory;